export default "__VITE_ASSET__3e726b19__"